export default __webpack_public_path__ + "static/media/fractal-completed-modal.97aa6432.png";